import api from "../../services/api";
import { Eventbus } from "../../utils";
import { events } from "../../utils/constants";

const landingService = (() => {
    let data = [];

    function getData() {
        return data;
    }

    function loadData() {
        return Promise.all([
            api.getCurrentIssues().then((issues) => {
                if (issues && issues.code === 'ERR_CANCELED') {
                    return data.issues; // Use existing issues if request was canceled
                }
                Eventbus.emit(events.STATS.ISSUES_LOADED, issues);
                return issues;
            }),
            api.getEmailStats().then((emails) => {
                if (emails && emails.code === 'ERR_CANCELED') {
                    return data.emails; // Use existing emails if request was canceled
                }
                Eventbus.emit(events.STATS.EMAIL_LOADED, emails);
                return emails;
            }),
            api.getGrandTotals().then((stats) => {
                if (stats && stats.code === 'ERR_CANCELED') {
                    return data.stats; // Use existing stats if request was canceled
                }
                Eventbus.emit(events.STATS.GRAND_TOTALS_LOADED, stats);
                return stats;
            })
        ]);
    }

    return {
        getData,
        loadData,
    };
})();

export default landingService;